import useSendUserStatus from '@/hooks/useSendUserStatus';

export default function SdkEvents() {
  useSendUserStatus();

  return null;
}
